/*
 * This is an auto-generated file, any manual edits will be overridden.
 *
 * To regenerate, see instructions here:
 *   https://kolibri-dev.readthedocs.io/en/develop/references/i18n.html
 *
 * This file was generated by frontend_build/src/intl_code_gen.js
 */
module.exports = function() {
  const data = [];
  data.push(require('vue-intl/locale-data/ar.js'));
  data.push(require('vue-intl/locale-data/bg.js'));
  data.push(require('vue-intl/locale-data/bn.js'));
  data.push(require('vue-intl/locale-data/en.js'));
  data.push(require('vue-intl/locale-data/es.js'));
  data.push(require('vue-intl/locale-data/es.js'));
  data.push(require('vue-intl/locale-data/fa.js'));
  data.push(require('vue-intl/locale-data/fr.js'));
  data.push(require('vue-intl/locale-data/ff.js'));
  data.push(require('vue-intl/locale-data/gu.js'));
  data.push(require('vue-intl/locale-data/hi.js'));
  data.push(require('vue-intl/locale-data/mr.js'));
  data.push(require('vue-intl/locale-data/my.js'));
  data.push(require('vue-intl/locale-data/nyn.js'));
  data.push(require('vue-intl/locale-data/pt.js'));
  data.push(require('vue-intl/locale-data/sw.js'));
  data.push(require('vue-intl/locale-data/te.js'));
  data.push(require('vue-intl/locale-data/ur.js'));
  data.push(require('vue-intl/locale-data/vi.js'));
  data.push(require('vue-intl/locale-data/yo.js'));
  return data;
};
